import type { ReactNode } from 'react';

export const symbol_timer_10_select: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M367-280h177v-400H367v400Zm0 80q-33.33 0-56.67-23.33Q287-246.67 287-280v-400q0-33.33 23.33-56.67Q333.67-760 367-760h177q33.33 0 56.67 23.33Q624-713.33 624-680v400q0 33.33-23.33 56.67Q577.33-200 544-200H367ZM127-680H80q-16.67 0-28.33-11.74Q40-703.47 40-720.24 40-737 51.67-748.5 63.33-760 80-760h82q18.75 0 31.88 13.12Q207-733.75 207-715v475q0 16.67-11.74 28.33Q183.53-200 166.76-200q-16.76 0-28.26-11.67Q127-223.33 127-240v-440Zm751 480H724q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h136v-70H736q-17 0-29.5-12.5T694-372v-106q0-17 12.5-29.5T736-520h154q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H754v70h124q17 0 29.5 12.5T920-348v106q0 17-12.5 29.5T878-200Z"
		/>
	</svg>
);
